module.exports = __webpack_public_path__ + "img/chess_chinesechessblack7.344da2fe.png";